module.exports = __webpack_public_path__ + "img/06-0资质1-2.3e57dc05.png";